import axios from "axios";

const users = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getFactorListByCustomerID(context, payload) {
            let response = await axios.get(`/buys_list_by_customer_id/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async upsertOrder(context, payload) {
            let response = await axios.post(`/Buys`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getOrderTraceList() {
            let response = await axios.get(`/Buys`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getOrderTraceListWithoutFinanceDocument() {
            let response = await axios.get(`/BuysNotIssueFinanceDocument`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async deleteOrderItem(context, payload) {
            let response = await axios.get(`/delete_buys_order_details_item/${payload.BuyNum}/${payload.BuyKind}/${payload.GoodsID}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async deleteFactorItem(context, payload) {
            let response = await axios.get(`/delete_buys_factor_details_item/${payload.BuyNum}/${payload.BuyKind}/${payload.GoodsID}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async issueBuyGoodsIntoStore(context, payload) {
            let response = await axios.get(`/issue_buy_goods_into_store/${payload.BuyNum}/${payload.BuyKind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getOrderDetails(context, payload) {
            let response = await axios.get(`/buys_order_details_info/${payload.buyNum}/${payload.buyKind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getOrder(context, payload) {
            let response = await axios.get(`/buys_order_info/${payload.buyNum}/${payload.buyKind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async changeBuyOrderState(context, payload) {
            let response = await axios.get(`/change_state/${payload.Buy_Num}/${payload.Buy_Kind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async upsertFactor(context, payload) {
            let response = await axios.post(`/generate_factors`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getFactorDetails(context, payload) {
            let response = await axios.get(`/get_buy_factor_details/${payload.Buy_Num}/${payload.Buy_Kind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getFactorHeader(context, payload) {
            let response = await axios.get(`/get_buy_factor_header/${payload.Buy_Num}/${payload.Buy_Kind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async deleteFactor(context, payload) {
            let response = await axios.get(`/delete_buy_factor/${payload.Buy_Num}/${payload.Buy_Kind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async orderArchived(context, payload) {
            let response = await axios.get(`/buyord_archive/${payload.Buy_Num}/${payload.Buy_Kind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getBuyOrderTrace(context, payload) {
            let response = await axios.get(`/get_buy_order_trace/${payload.Buy_Num}/${payload.Buy_Kind}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setBuyOrderTrace(context, payload) {
            let response = await axios.post(`/set_last_buy_order_trace`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getBuyReportYearly(context, payload) {
            let response = await axios.post(`/get_buy_report_yearly`, {
                selectedCompany: payload.selectedCompany,
                selectedUsers: payload.selectedUsers,
                selectedYear: payload.selectedYear === undefined ? '' : payload.selectedYear,
                selectedGoodsGroup: payload.selectedGoodsGroup,
                selectedStates: payload.selectedStates,
                selectedCities: payload.selectedCities,
                selectedGoods: payload.selectedGoods
            });
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getBuyMonthlyInYearData(context, payload) {
            let response = await axios.post(`/get_buy_report_monthly_year`, {
                selectedCompany: payload.selectedCompany,
                selectedUsers: payload.selectedUsers,
                selectedYear: payload.selectedYear === undefined ? '' : payload.selectedYear,
                selectedGoodsGroup: payload.selectedGoodsGroup,
                selectedStates: payload.selectedStates,
                selectedCities: payload.selectedCities,
                selectedGoods: payload.selectedGoods,
                dayOfMonth: payload.DayOfMonth
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async issueBuyFacReturn(context, payload) {
            let response = await axios.post(`/issue_buy_fac_return`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setFactorAttachmentFlag(context, payload) {
            let response = await axios.get(`/set_factor_attachment_flag/${payload.Buy_Num}/${payload.Buy_Kind}/${payload.flag}`);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async downloadFile(context, payload){
            let response = await axios.post(`/download_file`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
        async updateCustomer(context, payload) {
            let response = await axios.post(`/update_buy_order_customer`, payload);
            if (response.status === 200) {
                return response;
            } else {
                throw new Error('Can not load data');
            }
        },
    },
    getters: {}
}

export default users;
